// Third party.
require('./partials/modernizr.js');
var $ = jquery = window.jQuery; // = require('jquery');
require('tiny-slider');
// require('@fortawesome/fontawesome-free/js/all.js');

// import InfiniteScroll from "infinite-scroll";
import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination } from "swiper/core";
Swiper.use([Autoplay, Navigation, Pagination]);

var CountUp = require('countup.js');

// Default functionality for navigation/search etc.
var navigation = require('./sections/navigation.js')($, Modernizr);
var search = require('./sections/search.js')($);

// Default functionality for each section required on the website.
var banner = require('./sections/banner.js')($);
var twocolumn = require('./sections/two-column.js')($, Modernizr);
var countup = require('./sections/count-up.js')($, CountUp, Modernizr);
var logocarousel = require('./sections/logo-carousel.js')($);
var stickyelements = require('./sections/sticky-elements.js')($);
var accordion = require('./sections/accordion.js')($);

$(document).ready(function() {
    
    /**
     * Custom functionality and overrides.
     */


    const swiperReviews = new Swiper(".reviews .swiper-container", {
      loop: true,
      allowTouchMove: false,
      autoplay: {
        delay: 10000,
        pauseOnMouseEnter: false,
      },
      slidesPerView: 1,
      spaceBetween: 10,
      breakpoints: {
        // 992: {
        //   slidesPerView: 1,
        // },
      },
      pagination: {
        el: ".reviews .swiper-pagination",
        type: "bullets",
        clickable: true,
      },
      navigation: {
        nextEl: ".reviews .swiper-button-next",
        prevEl: ".reviews .swiper-button-prev",
      },
    });


    const swiperExplore = new Swiper(".explore-related .swiper-container", {
      loop: true,
      autoplay: {
        delay: 4000,
        pauseOnMouseEnter: false,
      },
      slidesPerView: 1,
      spaceBetween: 10,
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        992: {
          slidesPerView: 3,
        },
      },
      pagination: {
        el: ".explore-related .swiper-pagination",
        type: "bullets",
        clickable: true,
      },
    });

    const swiperRelated = new Swiper(".listing-related .swiper-container", {
      loop: true,
      autoplay: {
        delay: 4000,
        pauseOnMouseEnter: false,
      },
      slidesPerView: 1,
      spaceBetween: 10,
      allowTouchMove: false,
      breakpoints: {
        992: {
          slidesPerView: 2,
        },
      },
      pagination: {
        el: ".listing-related .swiper-pagination",
        type: "bullets",
        clickable: true,
      },
    });

    var count = $(".property-cards .type-property").length;
    if( count > 3 ) {
      var desktopLoop = true;
    } else {
      var desktopLoop = false;
    }
    const swiperProperties = new Swiper(".property-cards .swiper-container", {
      loop: true,
      allowTouchMove: false,
      autoplay: {
        delay: 4000,
        pauseOnMouseEnter: false,
      },
      slidesPerView: 1,
      spaceBetween: 10,
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        992: {
          loop: desktopLoop,
          slidesPerView: 3,
        },
      },
      pagination: {
        el: ".property-cards .swiper-pagination",
        type: "bullets",
        clickable: true,
      },
    });


    const swiperAbout = new Swiper(".about-slider .swiper-container", {
      loop: true,
      autoplay: {
        delay: 4000,
        pauseOnMouseEnter: false,
      },
      slidesPerView: 1,
      spaceBetween: 10,
      pagination: {
        el: ".about-slider .swiper-pagination",
        type: "bullets",
        clickable: true,
      },
    });

    $(".team-tab").on( 'click touch', function(e) {
        e.preventDefault();
        if( !$( this ).hasClass( 'active' ) ) {
            $( '.team-tab' ).removeClass( 'active' );
            $( '.team-members' ).hide(0);
            $(this).addClass( 'active' );
            var target = $( this ).attr( 'href' );
            $( target ).show(300);
        }
    });

    $(".team-button").on( 'click touch', function(e) {
        e.preventDefault();
        $(".overlay").hide();
        $(".team-member").css( 'padding-bottom', 0);
        var overlay = $(this).parents(".team-member").find(".overlay");
        var parent = $(this).parents(".team-member");
        var width = $( this ).parents(".team-grid").width();
        overlay.css("width", width);
        var height = overlay.outerHeight();
        parent.css("padding-bottom", height);

        var offset = parent.offset().left - parent.parent().offset().left;
        var tab_offset = offset + 125;
        overlay.css( 'left', '-' + offset + 'px' );
        overlay.find( '.tab' ).css( 'left', tab_offset + 'px' );
        overlay.show(300);
    })

    $(".team-member .close").on("click touch", function (e) {
      e.preventDefault();
      $(".overlay").hide();
      $(".team-member").css("padding-bottom", 0);
    });


    $( '.reviews .review .read-more' ).on( 'click touch', function(e) {
      e.preventDefault();
      $( this ).toggleClass( 'active' );
      $( this ).parents( '.review' ).find( '.content' ).toggleClass( 'active' );
    })



    if ($(".articles-list-container").length > 0 ) {
      var total = $("#post-list .article").length;
      $(".load-total .shown").text(total);


      let elem = document.querySelector(".articles-list-container");

      // let infScroll = new InfiniteScroll(elem, {
      //   // options
      //   path: ".pagination a",
      //   append: ".article",
      //   history: false,
      //   loadOnScroll: false
      // });
      //
      // var $viewMoreButton = $(".pagination a");
      //
      // $viewMoreButton.on("click", function (e) {
      //   e.preventDefault();
      //   infScroll.loadNextPage();
      // });
      //
      // infScroll.on(
      //   "append",
      //   function (event, path, fetchPromise) {
      //     var total = $("#post-list .article").length;
      //     $(".load-total .shown").text(total);
      //   }
      // );
      //
      // infScroll.on("last", function (event, response, path) {
      //   $viewMoreButton.hide();
      // });
    }


    $( 'footer h3' ).on( 'click touch', function(e) {
      e.preventDefault();
      $( this ).toggleClass( 'active' );
      $(this).parents(".menu").find( '.footer-menu').toggle(100);
    })

    $(".mobile-menu-toggle").on("click touch", function (e) {
      e.preventDefault();
      $( this ).toggleClass( 'active' );
      $(".mobile-menu").toggle();

    });

    $(".mobile-menu .menu li.menu-item-has-children > a").on(
      "click touch",
      function (e) {
        e.preventDefault();
        $(this).parent("li").find(".sub-menu-wrapper").first().show(0);
      }
    );

    $(".mobile-menu a.back").on(
      "click touch",
      function (e) {
        e.preventDefault();
        $( this ).parent( '.sub-menu-wrapper').hide(0);
      }
    );

    $(".count-up.visible .value-container .value").each(function () {
      var $this = $(this);

      var countTo = $this.parents(".value-container").data( 'to' );

      $({ countNum: $this.text() }).animate(
        {
          countNum: countTo,
        },

        {
          duration: 6000,
          easing: "linear",
          step: function () {
            $this.text(Math.floor(this.countNum).toLocaleString());
          },
          complete: function () {
            $this.text(this.countNum.toLocaleString());
            //alert('finished');
          },
        }
      );
    });

    $("#sort").on( 'change', function(){
      $( this ).parents( 'form' ).submit();
    });

    $(".hide-sold").on("change", function (e) {
      if ($(this).is(":checked")) {
        $(".hide-sold-hidden").val("true");
      } else {
        $(".hide-sold-hidden").val("false");
      }
      $(this).parents("form").submit();
    });

    $(".propertyhive-ordering input[type='checkbox']:not(.hide-sold)").on( 'change', function(e) {
      $(this).parents("form").submit();
    })




    var $el, $ps, $up, totalHeight;

    $(".about .read-more").click(function () {
      totalHeight = 0;

      $el = $(this);
      $up = $(this).parents(".about").find(".clipped");
      $ps = $up.find("p:not('.read-more')");

      totalHeight = $up.find( '.inner' ).outerHeight();

      $( this ).hide();
      $up
        .css({
          // Set height to prevent instant jumpdown when max height is removed
          height: $up.height(),
          "max-height": 9999,
        })
        .animate({
          height: totalHeight,
        })
        .addClass( 'open');

      // prevent jump-down
      return false;
    });


    $(".meta .share-toggle").on("click touch", function (e) {
      e.preventDefault();
      $(this).parents( 'li' ).find("ul").slideToggle(300);
      const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

        if (isMobile) {
            $('.facebook').hide();
            $('.facebook-mobile').show();
        } else {
            $('.facebook-mobile').hide();
            $('.facebook').show();
        }
    });


    $("#banner-search-form #search-sales").on("click touch", function (e) {
      e.preventDefault();
      var sales_action = $( '#sales-action' ).val();
      $( this ).parents( 'form' ).attr( 'action', sales_action ).submit();
    });

    $("#banner-search-form #search-let").on("click touch", function (e) {
      e.preventDefault();
      var let_action = $("#let-action").val();
      $(this).parents("form").attr("action", let_action).submit();
    });

    $("#quick-search-form #search-sales-header").on("click touch", function (e) {
      e.preventDefault();
      var sales_action = $("#sales-action-header").val();
      $(this).parents("form").attr("action", sales_action).submit();
    });

    $("#quick-search-form #search-let-header").on("click touch", function (e) {
      e.preventDefault();
      var let_action = $("#let-action-header").val();
      $(this).parents("form").attr("action", let_action).submit();
    });


    $(".prev-property-image").on("click touch", function (e) {
      e.preventDefault();
      var currentImg = $(".propertyhive-main-image").find( 'img' ).attr( 'src' );
      var html = '<a class="propertyhive-small-image col-span-1 small-image" href="' + currentImg + '" data-fancybox="gallery"><img src="' + currentImg + '" alt="" /></a>';

      $(".main-image").after(html);

      var prevImg = $(".thumbnail.grid > a:last-of-type").find("img").attr("src");
      $(".thumbnail.grid > a:last-of-type").remove();

      $(".propertyhive-main-image").attr("href", prevImg);
      $(".propertyhive-main-image").find("img").attr("src", prevImg);


    });

    $(".next-property-image").on( 'click touch', function(e) {
      e.preventDefault();
      var currentImg = $(".propertyhive-main-image").find( 'img' ).attr( 'src' );
      var html = '<a class="propertyhive-small-image col-span-1 small-image" href="' + currentImg + '" data-fancybox="gallery"><img src="' + currentImg + '" alt="" /></a>';

      $(".thumbnail.grid").append( html );
      var nextImg = $(".propertyhive-small-image").first().find('img').attr( 'src' );
      $(".propertyhive-small-image").first().remove();

      $(".propertyhive-main-image").attr("href", nextImg);
      $(".propertyhive-main-image").find( 'img' ).attr( 'src', nextImg );

    })


    $(".touch-template #step-1 a").on( 'click touch', function(e){
      e.preventDefault();
      var office_id = $( this ).data( 'office' );
      $("#office-id").val( office_id );
      $( '#step-1' ).hide();
      $( '#step-2').css( 'display', 'flex' );
    })


    $("body").on("click touch", ".close-modal", function (e) {
      e.preventDefault();
      var magnificPopup = $.magnificPopup.instance;
      magnificPopup.close();
    });

    $(".ajax-property").click(function (e) {
      e.preventDefault();
      property_id = $(this).data('property');

      $.ajax({
        type: "GET",
        dataType: "json",
        url: myAjax.ajaxurl,
        data: {
          action: "get_ajax_property",
          property_id: property_id
        },
        success: function (response) {

          $("#property-popup .inner").empty().html( response.data );
          $.magnificPopup.open(
            {
              items: {
                src: "#property-popup",
              },
              type: "inline",
              mainClass: "mfp-fade",
              removalDelay: 160,
              preloader: false,
              fixedContentPos: false,
              closeOnBgClick: true,
              callbacks: {
                open: function () {
                  $("body").css("overflow", "hidden"); // window, the element

                  const swiperPropertySlider = new Swiper(
                    ".property-slider .swiper-container",
                    {
                      loop: true,
                      autoplay: {
                        delay: 4000,
                        pauseOnMouseEnter: false,
                      },
                      slidesPerView: 1,
                      spaceBetween: 0,
                      navigation: {
                        nextEl: ".property-slider .swiper-button-next",
                        prevEl: ".property-slider .swiper-button-prev",
                      },
                      thumbs: {
                        swiper: swiperPropertyThumbs,
                      }
                    }
                  );

                  const swiperPropertyThumbs = new Swiper(
                    ".property-thumbs .swiper-container",
                    {
                      loop: true,
                      autoplay: {
                        delay: 4000,
                        pauseOnMouseEnter: false,
                      },
                      direction: "vertical",
                      slidesPerView: 5,
                      spaceBetween: 10,
                      watchOverflow: true,
                      watchSlidesVisibility: true,
                      watchSlidesProgress: true,
                      navigation: {
                        nextEl: ".property-thumbs .swiper-button-next",
                        prevEl: ".property-thumbs .swiper-button-prev",
                      },
                    }
                  );

                  swiperPropertySlider.on("slideChangeTransitionStart", function () {
                    swiperPropertyThumbs.slideTo(swiperPropertySlider.activeIndex);
                  });

                  swiperPropertyThumbs.on("transitionStart", function () {
                    swiperPropertySlider.slideTo(swiperPropertyThumbs.activeIndex);
                  });


                }, // "body" is used "overflow: hidden".

                close: function () {
                  // When the window
                  $("body").css("overflow", ""); // is closed, the
                }, // "overflow" gets the initial value.
              }
            },
            0
          );
        },
      });
    });

    $("body").on('click touch', "#image-gallery-button", function(e) {
      e.preventDefault();
      $( '.overlay' ).hide();
    });

    $("body").on("click touch", "#floor-plans-button", function (e) {
      e.preventDefault();
      $(".overlay").hide();
      $("#floor-plans").show();
    });

    $("body").on("click touch", "#main-content-button", function (e) {
      e.preventDefault();
      $(".overlay").hide();
      $("#main-content").show();
    });


    $("body").on("click touch", "#property-popup .overlay .button-up", function(e){
      e.preventDefault();
      var $elem = $(this).parents(".overlay").find( '.inner' );
      $elem.scrollTop($elem.scrollTop() - 150);
    });

    $("body").on("click touch", "#property-popup .overlay .button-down", function(e){
      e.preventDefault();
      var $elem = $(this).parents(".overlay").find( '.inner' );
      $elem.scrollTop($elem.scrollTop() + 150);
    });


});
